class InvestorProfile {
    id;
    consecutiveNumber;
    email;
    fullName;
    firstLastName;
    secondLastName;
    phone;
    curp;
    taxId;
    birthdate;
    birthCountry;
    birthState;
    gender;
    nationality;
    isRealOwner;
    realOwnerName;
    realOwnerBirthdate;
    hasOwnResources;
    identification;
    address;
    addressProof;
    jobTitle;
    transactionalProfile;
    status;
    dataUpdateInfo;
    constructor(data) {
        this.id = data.id;
        this.consecutiveNumber = data.consecutiveNumber;
        this.email = data.email;
        this.fullName = data.fullName;
        this.firstLastName = data.firstLastName;
        this.secondLastName = data.secondLastName;
        this.phone = data.phone;
        this.curp = data.curp;
        this.taxId = data.taxId;
        this.birthdate = data.birthdate;
        this.birthCountry = data.birthCountry;
        this.birthState = data.birthState;
        this.gender = data.gender;
        this.nationality = data.nationality;
        this.isRealOwner = data.isRealOwner;
        this.realOwnerName = data.realOwnerName;
        this.realOwnerBirthdate = data.realOwnerBirthdate;
        this.hasOwnResources = data.hasOwnResources;
        this.identification = data.identification;
        this.address = data.address;
        this.addressProof = data.addressProof;
        this.jobTitle = data.jobTitle;
        this.transactionalProfile = data.transactionalProfile;
        this.status = data.status;
        this.dataUpdateInfo = data.dataUpdateInfo;
    }
}
export default InvestorProfile;
